<template>
  <div  class="OrderManageList-root">
    <div v-if="authority" class="search-pane">
       <div class="search_content">
         <pro-search 
      :fileds="BatchSearchFiled"
      :form="queryForm"
      @search="handleSearch"
      @reset="handleReset"
      >
        <template slot="warehouseCode">
          <div v-if="!isNowWaCustomer">
            <!-- <cascaderSelect ref="cascaderSelect" @change="handleWhChange"></cascaderSelect> -->
            <select-dom  v-model="queryForm.shipperId" :is-every-request="false" :list="ProjectList" @onSearch="onSearchProject" @checkedList="checkedList" />
          </div>
          <wareHouse-select  v-else :select-ware="queryForm.warehouseCodeCustomers" :option="ProjectList" @change="handleChange" />
        </template>
        <template slot="batchAttrName">
           <a-input-group compact>
                <a-select
                  v-model="queryForm.batchAttrName"
                  style="width: 120px;"
                  :get-popup-container="triggerNode => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in BATCHLIST"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{item.label}}
                  </a-select-option>
                </a-select>
                <a-input
                  v-model="queryForm.batchAttrValue"
                  placeholder="请输入"
                  style="width: calc(100% - 120px);"
                  @pressEnter="getData"
                />
              </a-input-group>
        </template>
      </pro-search>
       </div>
      <div v-if="authority" class="table-content">
        <div class="operate_bar">
          <a-button class="btn_export" @click="handleExport">导出</a-button>
        </div>
      <a-table
        :loading="tableLoading"
        :columns="TableColumns"
        :data-source="goodsData"
        class="table-sigle"
        row-key="id"
        :scroll="{ x: 'calc(700px + 50%)'}"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template slot="goodsName" slot-scope="text">
          <a-tooltip>
            <template slot="title">{{text}}</template>
            <p class="overlength">{{text}}</p>
            </a-tooltip>
        </template>
      </a-table>
    </div>
    <div v-else class="noAuthority">
      暂未对个人货主开放，敬请期待
    </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import SelectDom from '@/components/select/SelectDom'
import { EventBus } from '@/utils/event-bus'
import ProSearch from '@/components/TableSearch/index.vue'
import { batchTableColumns,BatchSearchFiled } from '../constant.js'
import { getWareHouse } from '../../../../warehouseOrder/api'
import { exportStockByBatch } from '../../../overview/api'
import wareHouseSelect from '../../component/warehouseSelect.vue'
import {warehouseStockContainerBatchPage} from '../../api'

const BATCHLIST = [
  {
    value: 'box_no',
    label: '柜号',
  },
  {
    value: 'customer_batch',
    label: '客户批次',
  },
  {
    value: 'expire_date',
    label: '到期日期',
  },
  {
    value: 'inspectionQuearantineCode',
    label: '检验检疫文',
  },
  {
    value: 'productDate',
    label: '生产日期',
  },
  {
    value: 'store_date',
    label: '入库日期',
  },
  {
    value: 'store_no',
    label: '入库单号',
  },
  {
    value: 'traceCode',
    label: '追溯码',
  },
]

export default {
  name: 'Batch',
  components: {
    SelectDom,
    // cascaderSelect,
    ProSearch,
    wareHouseSelect
  },
   props:{
      checkTab:{
        type:String,
        default:'batch'
      },
      isNowWaCustomer:{
        type:Boolean,
        default:()=>false
      }
    },
  data () {
    return {
      BatchSearchFiled,
      authority: true,
      openMore: false,
      goodsData: [],
      isEnterprise:false,
      pageSize: 10,
      pagination: {
          current: 1,
          total: 0,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          onShowSizeChange: (current, pageSize) => {
            this.pageSize = pageSize
          },
          showQuickJumper: true,
          showTotal: total => `共 ${total} 条`
      },
      ProjectList: [],
      queryForm: {
        warehouseCode: '',
        goodsName: '',
        goodsCode: '',
        batchNo: '',
        batchAttrName: 'box_no',
        batchAttrValue: '',
        shipperId: '',
      },
      BATCHLIST,
      tableLoading:false
    }
  },
  computed: {
    TableColumns(){
      return batchTableColumns(this.isNowWaCustomer)
    }
  },
  watch:{
      checkTab(){
        if(this.checkTab==='batch'){
         this.getData();
        }
      }
    },
  created() {
    // const {creditCode}=this.$store.state.user
    //   if(!creditCode){
    //     this.getWareHouse()
    //   }
    //   this.isEnterprise=!!creditCode
  },
  methods: {
      init(){
         this.getWareHouse()
      },
    async handleExport() {
      if (this.goodsData.length) {
        const {warehouseCodes,customerIds,warehouseCode,shipperId,warehouseCodeCustomers,...restParams}=this.queryForm;
        if(!this.isNowWaCustomer&&!shipperId){
          this.$message.warning('未选择仓库,无法查询数据')
          return
        }
        const data={
          ...restParams
        };
        if(this.isNowWaCustomer){
          data.warehouseCodes=warehouseCodes;
          data.customerIds=customerIds;
        }else{
          data.warehouseCode=warehouseCode;
          data.customerIds=[shipperId];
        }
        await exportStockByBatch(data)
        EventBus.$emit('taskPopover')
      } else {
        this.$message.warning('当前列表无数据,不支持导出')
      }
    },
     handleSearch(form){
      this.pagination.current=1
      this.queryForm={
        ...form,
      }
      this.getData();
    },
    handleWhChange(data){
      this.ProjectList=[data]
       if(data){
        this.queryForm.warehouseCode =data.tenantId
        this.queryForm.shipperId =data.customerId
        this.getData(true)
        }else{
          this.queryForm.warehouseCode =''
          this.queryForm.shipperId =''
            this.getData(true)
        }
    },
    checkedList(data){
      this.queryForm.shipperId = data.customerId;
      this.queryForm.warehouseCode = data.tenantId;
      this.getData(true)
    },
    handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current
      }
      this.getData();
    },
   async getData(current = null){
      if(current){
        this.pagination.current = 1
      }
      this.tableLoading=true;
      const params = {
        size: this.pageSize,
        page: this.pagination.current
      }
       const {warehouseCodes,customerIds,warehouseCode,shipperId,warehouseCodeCustomers,...restParams}=this.queryForm;
      if(!this.isNowWaCustomer&&!shipperId){
        this.$message.warning('未选择仓库,无法查询数据')
        this.tableLoading=false;
        return
      }
      const data={
        ...restParams
      };
      if(this.isNowWaCustomer){
        data.warehouseCodes=warehouseCodes;
        data.customerIds=customerIds;
      }else{
        data.warehouseCode=warehouseCode;
        data.customerIds=[shipperId];
      }
      try {
        const res= await warehouseStockContainerBatchPage(data, params)
        this.goodsData = res.records
        this.pagination.total = res.total
        this.tableLoading=false
      } catch (error) {
        this.goodsData =[]
        this.pagination.total = 0
        this.tableLoading=false
      }
    },
    handleReset(){
      this.$refs.cascaderSelect.handleClear()
      this.$set(this,'queryForm', {
        // warehouseCode: this.ProjectList[0].tenantId,
        goodsName: '',
        goodsCode: '',
        batchNo: '',
        batchAttrName: '柜号',
        batchAttrValue: '',
        // shipperId: this.ProjectList[0].customerId,
      })
      this.getData();
    },
    onSearchProject(tenantName){
      this.getWareHouse(tenantName)
    },
    getWareHouse(tenantName=null){
      const data = {
          customerCodes: [this.$store.state.user.customerCode],
          needExcludeDefaultTenant: true,
          tenantName,
          isReadConfig:true,
      }
      if(this.isNowWaCustomer){
        data.isReadConfig=true
        data.type='DELIVER'
      }
      getWareHouse(data,{size:500}).then((res) => {
        if(res.records.length <= 0){
          this.ProjectList = []
          this.$message.warning('未选择仓库,无法查询数据')
          return
        }
        const arr = res.records.map((e) => {
           if(!this.isNowWaCustomer){
            return {
                ...e,
                label:e.tenantName,
                formatLabel: `${e.tenantName} (${e.shipperName})`,
                value: e.customerId
            }
          }
            return {
                ...e,
                label: e.tenantName,
                formatLabel: `${e.tenantName} (${e.shipperName})`,
                value: e.customerId
            }
        })
        this.ProjectList = arr
        if(this.goodsData.length <= 0){
          if(arr.length > 0 && !this.queryForm.shipperId ){
            if(!this.isNowWaCustomer){
              this.queryForm.warehouseCode = arr[0].tenantId;
              this.queryForm.shipperId = arr[0].customerId;
            }
          }
          this.getData()
        }
      })
    },
    handleChange(value){
      this.queryForm.customerIds=[];
      this.queryForm.warehouseCodes=[];
      this.ProjectList.forEach(item=>{
        if(value.includes(item.value)){
          this.queryForm.customerIds.push(item.customerId)
          this.queryForm.warehouseCodes.push(item.tenantId)
        }
      })
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
.table-content {
  border-top: 1px solid #E7E9EC;
  padding-top: 24px;
  // padding: 12px 30px;
  // margin-top: 5px;
  // background-color: #fff;
  // border-radius: 6px;
  .operate_bar {
    margin-bottom: 24px;
    .btn_export {
      border: 1px solid #06B880;
      color: #06B880;
    }
  }
}
.search_content {
  margin-bottom: 12px;
}
.search-pane {
  padding: 24px;
  background-color: #fff;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.search-btn {
  margin-top: 20px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.moreData {
  height: 30px;
  line-height: 30px;
  background-color: #fff;
  font-size: 12px;
  &:hover {
    cursor: pointer;
  }
}
.nextForm{
  margin-top: 15px;
  transition: all ease .2s;
}
.nextFormActive{
  height: auto;
}
.form-row {
  .formTitle{
    text-align: right;
    padding-right: 6px;
    width: 100%;
    display: inline-block;
    font-size: 0.8rem;
    line-height: 32px;
  }
}
.orderName {
  padding-left: 80px;
  .ant-input-group {
    width: 300px;
  }
}
.batch_form {
    /deep/.ant-form-item {
      width: 100%;
      .ant-form-item-label {
        width: 80px;
      }
      .ant-form-item-control-wrapper {
        width: calc(100% - 80px);
      }
    }
    .ant-col-6 {
      padding-right: 20px;
    }
    .form-btns {
      text-align: center;
      .form-btn {
        margin-left: 20px;
      }
    }
  }
  .batch_form {
    /deep/.ant-form-item-label label {
      color: #606266;
    }
    /deep/ .ant-form-item-control-wrapper input {
      color: #171717 !important;
    }

  }
  .search_btn {
    color: #06B880;
    border-color: #06B880;
  }
  .overlength {
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
</style>